export enum KeyboardEvents {
  KEYUP = 'keyup',
  KEYDOWN = 'keydown',
  PASTE = 'paste',
  CLICK = 'click',
  CONTEXT_MENU = 'contextmenu',
};
